import { render, staticRenderFns } from "./scrollToTop.vue?vue&type=template&id=9c1d3740&scoped=true"
import script from "./scrollToTop.vue?vue&type=script&lang=js"
export * from "./scrollToTop.vue?vue&type=script&lang=js"
import style0 from "./scrollToTop.vue?vue&type=style&index=0&id=9c1d3740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1d3740",
  null
  
)

export default component.exports